import DrawerLayout from 'layouts/DrawerLayout';
import MobileLayout from 'layouts/MobileLayout';
import Cart from 'pages/Cart';
import Home from 'pages/Home';
import MenuHome from 'pages/Menu/MenuHome';
import Product from 'pages/Menu/Product';
import NotFound from 'pages/NotFound';
import Payment from 'pages/Payment';
import OrderConfirmation from 'pages/OrderConfirmation';
import OrderError from 'pages/OrderError';
import TermsAndConditions from 'pages/TermsAndConditions';
import { RouteDeclaration, Routes } from './routes.types';

export const routes: RouteDeclaration[] = [
    {
        name: 'home',
        path: Routes.Home,
        element: <Home />,
        layout: <DrawerLayout />,
    },
    {
        name: 'menu_home',
        path: Routes.MenuHome,
        element: <MenuHome />,
        layout: <MobileLayout />,
    },
    {
        name: 'product_name_route',
        path: Routes.Product,
        element: <Product />,
        layout: <MobileLayout />,
    },
    {
        name: 'payment',
        path: Routes.Payment,
        element: <Payment />,
        layout: <MobileLayout />,
    },
    {
        name: 'notFound_message',
        path: Routes.NotFound,
        element: <NotFound />,
        layout: <DrawerLayout />,
    },
    {
        name: 'cart',
        path: Routes.Cart,
        element: <Cart />,
        layout: <MobileLayout />,
    },
    {
        name: 'orderConfirmation',
        path: Routes.OrderConfirmation,
        element: <OrderConfirmation />,
        layout: <DrawerLayout />,
    },
    {
        name: 'order_error',
        path: Routes.OrderError,
        element: <OrderError />,
        layout: <DrawerLayout />,
    },
    {
        name: 'terms_and_conditions',
        path: Routes.TermsAndConditions,
        element: <TermsAndConditions />,
        layout: <MobileLayout />,
    },
];
